// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  life: __t.u32(),
  attackReadyAt: __t.timestamp().name("attack_ready_at"),
  equipReadyAt: __t.timestamp().name("equip_ready_at"),
  pendingActionId: __t.u64().name("pending_action_id"),
  combatLockUntil: __t.timestamp().name("combat_lock_until"),
  staggerResistUntil: __t.timestamp().name("stagger_resist_until"),
  protectedUntil: __t.timestamp().name("protected_until"),
  regenAt: __t.timestamp().name("regen_at"),
  regenAcc: __t.f32().name("regen_acc"),
  lastDownedAt: __t.timestamp().name("last_downed_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
